import * as React from "react";
const SvgFiRrSnowmanHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 9h-2V5c0-2.757-2.243-5-5-5h-4C7.243 0 5 2.243 5 5v4H3a1 1 0 1 0 0 2h.947A9 9 0 0 0 3 15c0 4.963 4.038 9 9 9s9-4.037 9-9a9 9 0 0 0-.947-4H21a1 1 0 1 0 0-2M7 5c0-1.654 1.346-3 3-3h4c1.654 0 3 1.346 3 3v4H7zm5 17c-3.86 0-7-3.141-7-7 0-1.457.456-2.823 1.283-4h11.433a6.9 6.9 0 0 1 1.283 4c0 3.859-3.14 7-7 7zm-2-7.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 10 14.5m7 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 14.5m-3.5 2.995c0 .398-.349 1.687-.71 2.914-.232.787-1.349.787-1.581 0-.361-1.228-.71-2.516-.71-2.914 0-.826.672-1.495 1.5-1.495s1.5.669 1.5 1.495z"
    />
  </svg>
);
export default SvgFiRrSnowmanHead;
